module.exports = __webpack_public_path__ + "static/media/step-1-navigate-to-private-apps.7913f270.png";